
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { AppModule } from '@/store/modules/app';

@Component({
  name: 'ImgLarge'
})
export default class extends Vue {
  private currentIndex: number = 0
  private carouselCount: number = 0
  private enlargedLoc:any = {}
  private rotate = true;

  // 缩放 / 平移 / 全屏
  private scale: number = 1;
  private posX: number = 0;
  private posY: number = 0;
  private minScale: number = 0.5;
  private maxScale: number = 8;
  private isFullscreen: boolean = true;
  private isDragging: boolean = false;
  private dragStartX: number = 0;
  private dragStartY: number = 0;
  private dragOriginX: number = 0;
  private dragOriginY: number = 0;
  private onDocMove: any = null;
  private onDocUp: any = null;

  get enlarged() {
    let urlArr = [];
    let len = AppModule.getEnlarged.imgList.length;
    for (let i = 0; i < len; i++) {
      if (AppModule.getEnlarged.imgList[i].media_type === '2') {
        urlArr.push({
          img_url: '',
          video_url: AppModule.getEnlarged.imgList[i].full_path,
          isRotate1: false,
          isRotate2: false,
          isRotate3: false
        });
      } else {
        urlArr.push({
          img_url: AppModule.getEnlarged.imgList[i].img_url ? AppModule.getEnlarged.imgList[i].img_url : AppModule.getEnlarged.imgList[i],
          video_url: AppModule.getEnlarged.imgList[i].video_url ? AppModule.getEnlarged.imgList[i].video_url : '',
          isRotate1: false,
          isRotate2: false,
          isRotate3: false
        });
      }
    }
    this.enlargedLoc = {
      imgList: urlArr
    };
    const res = {
      ...AppModule.getEnlarged
    };
    return res;
  }

  get isGrab() {
    return true;
  }

  get scalePercent() {
    return `${Math.round(this.scale * 100)}%`;
  }

  get rotateDeg(): number {
    const item = this.enlargedLoc.imgList && this.enlargedLoc.imgList[this.currentIndex];
    if (!item) {
      return 0;
    }
    if (item.isRotate1) {
      return 90;
    }
    if (item.isRotate2) {
      return 180;
    }
    if (item.isRotate3) {
      return 270;
    }
    return 0;
  }

  get mediaStyle() {
    return {
      transform: `translate(${this.posX}px, ${this.posY}px) scale(${this.scale}) rotate(${this.rotateDeg}deg)`
    };
  }

  private close() {
    this.enlarged.isShow = false;
    this.carouselCount = 0;
    this.currentIndex = 0;
    this.isFullscreen = true;
    this.resetTransform();
    this.$store.dispatch('toggleEnlarged', this.enlarged);
  }

  rotateHandle(val: number) {
    for (let i = 0; i < this.enlargedLoc.imgList.length; i++) {
      this.enlargedLoc.imgList[i].isRotate1 = false;
      this.enlargedLoc.imgList[i].isRotate2 = false;
      this.enlargedLoc.imgList[i].isRotate3 = false;
    }
    this.carouselCount++;
    if (this.carouselCount === 4) {
      this.carouselCount = 0;
    }
    switch (this.carouselCount) {
      case 1:
        this.enlargedLoc.imgList[val].isRotate1 = true;
        break;
      case 2:
        this.enlargedLoc.imgList[val].isRotate2 = true;
        break;
      case 3:
        this.enlargedLoc.imgList[val].isRotate3 = true;
        break;
      default:
        this.enlargedLoc.imgList[val].isRotate1 = false;
        this.enlargedLoc.imgList[val].isRotate2 = false;
        this.enlargedLoc.imgList[val].isRotate3 = false;
        break;
    }
  }

  carouselChangeHandle(index: number) {
    this.currentIndex = index;
    this.carouselCount = 0;
    this.resetTransform();
  }

  // 滚轮缩放
  wheelHandle(e: WheelEvent) {
    const factor = e.deltaY < 0 ? 1.2 : 1 / 1.2;
    this.zoomHandle(factor, e);
  }

  // 缩放，传入鼠标事件时以鼠标位置为中心缩放
  zoomHandle(factor: number, e?: WheelEvent | MouseEvent) {
    const oldScale = this.scale;
    const newScale = Math.min(this.maxScale, Math.max(this.minScale, oldScale * factor));
    if (newScale === oldScale) {
      return;
    }
    if (e && e.target) {
      const rect = (e.target as HTMLElement).getBoundingClientRect();
      const px = e.clientX - (rect.left + rect.width / 2);
      const py = e.clientY - (rect.top + rect.height / 2);
      const ratio = 1 - newScale / oldScale;
      this.posX += px * ratio;
      this.posY += py * ratio;
    }
    this.scale = newScale;
  }

  // 按住拖动，移动可视区域（不放大也可移动，配合旋转/缩放查看）
  mouseDownHandle(e: MouseEvent) {
    e.stopPropagation();
    e.preventDefault();
    this.isDragging = true;
    this.dragStartX = e.clientX;
    this.dragStartY = e.clientY;
    this.dragOriginX = this.posX;
    this.dragOriginY = this.posY;
    this.onDocMove = (ev: MouseEvent) => {
      if (!this.isDragging) {
        return;
      }
      this.posX = this.dragOriginX + (ev.clientX - this.dragStartX);
      this.posY = this.dragOriginY + (ev.clientY - this.dragStartY);
    };
    this.onDocUp = () => {
      this.dragEndHandle();
    };
    document.addEventListener('mousemove', this.onDocMove);
    document.addEventListener('mouseup', this.onDocUp);
  }

  dragEndHandle() {
    this.isDragging = false;
    if (this.onDocMove) {
      document.removeEventListener('mousemove', this.onDocMove);
      this.onDocMove = null;
    }
    if (this.onDocUp) {
      document.removeEventListener('mouseup', this.onDocUp);
      this.onDocUp = null;
    }
  }

  // 双击：放大状态还原，原始尺寸时放大2倍
  dblclickHandle(e: MouseEvent) {
    if (this.scale > 1) {
      this.resetTransform();
    } else {
      this.zoomHandle(2, e);
    }
  }

  resetTransform() {
    this.scale = 1;
    this.posX = 0;
    this.posY = 0;
  }

  toggleFullscreen() {
    this.isFullscreen = !this.isFullscreen;
    this.resetTransform();
  }

  beforeDestroy() {
    this.dragEndHandle();
  }
}
